import React, { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Subscription } from './components/Subscription'
import { BillingMenu } from './components/BillingMenu'
import { Addons } from './components/Addons'
import { Invoices } from './components/Invoices'
import styles from './Billing.module.scss'

export const Billing: FC = () => {
  return (
    <div className={styles.billing}>
      <BillingMenu />
      <div className={styles.content}>
        <Routes>
          <Route path="/" element={<Subscription />} />
          <Route path="/addons" element={<Addons />} />
          <Route path="/invoices" element={<Invoices />} />
        </Routes>
      </div>
    </div>
  )
}

Billing.displayName = 'Billing'
